export default defineAppConfig({
  icon: {
    customize: (content: string) => {
      return content.replace(/stroke-width="2"/g, `stroke-width="1.5" vector-effect="non-scaling-stroke"`)
    },
  },
  ui: {
    colors: {
      primary: 'qb-green',
      secondary: 'qb-purple',
      accent: 'qb-yellow',
    },
    button: {
      slots: {
        label: 'text-qb-black',
        leadingIcon: 'text-qb-black',
        trailingIcon: 'text-qb-black',
      },
    },
    card: {
      slots: {
        root: 'rounded-lg shadow-md',
      },
    },
  },
})